type ResponsiveImageProps = {
  alt: string;
  src: string;
  srcSet: string;
  sizes: string;
  width: number;
  height: number;
  className?: string;
  loading?: "lazy" | "eager";
  fetchPriority?: "high" | "low" | "auto";
  decoding?: "async" | "sync" | "auto";
};

export function srcSet(entries: ReadonlyArray<readonly [string, number]>) {
  return entries.map(([url, width]) => `${url} ${width}w`).join(", ");
}

export function ResponsiveImage({
  alt,
  src,
  srcSet: srcSetValue,
  sizes,
  width,
  height,
  className,
  loading = "lazy",
  fetchPriority,
  decoding = "async",
}: ResponsiveImageProps) {
  return (
    <img
      src={src}
      srcSet={srcSetValue}
      sizes={sizes}
      alt={alt}
      width={width}
      height={height}
      loading={loading}
      decoding={decoding}
      fetchPriority={fetchPriority}
      className={className}
    />
  );
}
